// extracted by mini-css-extract-plugin
module.exports = {"root":"IconArrow_root__3G4WJ"};